const SEARCH_INPUT_CLASS = '.js-search-input';
const INPUT_CLASS = '.js-search-input-input';
const REMOVE_CLASS = '.js-search-input-remove';

const $searchInputs = $(SEARCH_INPUT_CLASS);

const searchInput = {
  initialize() {
    if (!$searchInputs.length) {
      return;
    }

    this.createListeners();

    $searchInputs.toArray().forEach((input) => {
      this.checkRemoveVisibility(input.querySelector(INPUT_CLASS));
    });
  },

  createListeners() {
    $searchInputs.on('keyup', INPUT_CLASS, (e) => {
      this.checkRemoveVisibility(e.currentTarget);
    });

    $searchInputs.on('click', REMOVE_CLASS, (e) => {
      const $searchInput = this.getParent(e.currentTarget);
      const $input = $searchInput.find(INPUT_CLASS);
      $input.val('').trigger('keyup');
    });
  },

  getParent(el) {
    return $(el).parents(SEARCH_INPUT_CLASS);
  },

  checkRemoveVisibility(item) {
    const $searchInput = this.getParent(item);
    const $input = $searchInput.find(INPUT_CLASS);
    const $remove = $searchInput.find(REMOVE_CLASS);
    $remove.toggleClass('is-visible', $input.val().toString().length > 0);
  },
};

export default searchInput;
